import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

import Button from '../../Forms/Button';
import { numberToCurrencyString } from '../../../services/formatting';
import './Account.payment.choice.scss';

type ChoiceOption = 'plan' | 'recarga';

interface AccountPaymentChoiceProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onChoosePlan: () => void;
    onChooseRecarga: () => void;
    cheapestPlanCfdiCostPesos: number | null;
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '90vh',
        maxWidth: '480px',
        padding: '0px',
        border: 'none',
        borderRadius: '16px',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)'
    }
};
Modal.setAppElement('#root');

function AccountPaymentChoice({
    isOpen,
    onRequestClose,
    onChoosePlan,
    onChooseRecarga,
    cheapestPlanCfdiCostPesos
}: AccountPaymentChoiceProps) {
    const [choice, setChoice] = useState<ChoiceOption | null>(null);

    useEffect(() => {
        if (!isOpen) setChoice(null);
    }, [isOpen]);

    const handleContinue = () => {
        if (choice === 'plan') {
            onChoosePlan();
        } else if (choice === 'recarga') {
            onChooseRecarga();
        }
    };

    const planCostText = cheapestPlanCfdiCostPesos
        ? `Desde $${numberToCurrencyString(cheapestPlanCfdiCostPesos)} MXN por factura con plan`
        : 'Reduce tu costo por factura con un plan mensual';

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            style={customStyles}
            ariaHideApp={false}
            contentLabel="Elegir método para agregar saldo"
        >
            <div id="AccountPaymentChoice">
                <h4 className='title'>Agregar saldo</h4>
                <p className='subtitle'>Puedes bajar tu costo de facturación con un plan</p>
                <div className='choiceList'>
                    <button
                        type='button'
                        className={`choiceCard plan ${choice === 'plan' ? 'selected' : ''}`}
                        onClick={() => setChoice('plan')}
                    >
                        <div className='choiceHeading'>
                            <span className='choiceTitle'>Baja tu costo con un Plan</span>
                            <i className='material-icons choiceIcon'>credit_card</i>
                        </div>
                        <p className='choiceSub'>{planCostText}</p>
                    </button>
                    <button
                        type='button'
                        className={`choiceCard recarga ${choice === 'recarga' ? 'selected' : ''}`}
                        onClick={() => setChoice('recarga')}
                    >
                        <div className='choiceHeading'>
                            <span className='choiceTitle'>Prefiero quedarme con Recarga</span>
                            <i className='material-icons choiceIcon'>account_balance_wallet</i>
                        </div>
                        <p className='choiceSub'>Costo por factura a $2.95 MXN</p>
                    </button>
                </div>
                <div className='actionRow'>
                    <Button tertiary size='small' handleClick={onRequestClose}>
                        <span>Cancelar</span>
                    </Button>
                    <Button primary size='small' disabled={!choice} handleClick={handleContinue}>
                        <span>Continuar</span>
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default AccountPaymentChoice;
